import React, { useEffect } from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import {
  TCompanyInfo,
  TStripePlan,
  TSubscription,
  useActivateSubscriptionMutation,
} from '@/features/subscription/apiSlice';
import AjaxSpinner from '@/components/AjaxSpinner';
import nwCSS from '@/css/module/new-world.css';
import { formatPrice } from '@/features/subscription/components/utils';
import { UNITED_KINGDOM } from '@/components/billing/CompanyDetailsModal';
import { useDatasourceId } from '@/hooks';
import { Button, TrevorIcon } from '@trevor/ui-components';

export const ActivateButton: React.FC<{
  disabled: boolean;
  selectedPlan: TStripePlan;
  companyInfo: TCompanyInfo;
  coupon: string;
  subscription: TSubscription;
  onActivation: F0;
}> = ({
  disabled,
  selectedPlan,
  companyInfo,
  coupon,
  subscription,
  onActivation,
}) => {
  const [update, response] = useActivateSubscriptionMutation();
  const datasourceId = useDatasourceId();

  useEffect(() => {
    if (response?.data?.status === 'active') {
      onActivation();
    }
  }, [response?.data?.status]);

  const activate = () => {
    update({
      datasourceId,
      plan: selectedPlan.id,
      coupon,
    });
  };

  const isUKCustomer = companyInfo.country === UNITED_KINGDOM;

  const price = () => {
    if (!selectedPlan) {
      return '';
    }
    const taxRate = isUKCustomer ? 0.2 : 0.0;
    return formatPrice(
      selectedPlan.price,
      true,
      selectedPlan.currency,
      false,
      taxRate,
    );
  };

  if (subscription.subscriptionStatus) {
    return null;
  }

  return (
    <div className={`${css.section} margin-top-10 ${flex.justifyContentStart}`}>
      <div className={`${flex.column} ${flex.justifyContentCenter}`}>
        {response.isLoading ? (
          <AjaxSpinner small />
        ) : (
          <div>
            <Button
              size="large"
              onClick={activate}
              disabled={disabled}
              className={`${!disabled ? nwCSS.notification : ''}`}
              icon={<TrevorIcon name="locked" />}
            >
              Pay {price()}
              {isUKCustomer ? <span>*</span> : null} and activate
            </Button>
            <div className="w-100 margin-top-15 text-align-center">
              <small className="w-100 text-align-center">
                {isUKCustomer ? <span>*Includes 20% VAT. </span> : null}
                <span>You can cancel anytime.</span>
              </small>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
